import classnames from 'classnames'
import TextWrapper from './TextWrapper'
// import IconButton from './IconButton'
import React, { useState, useEffect } from 'react'
import './PopOver.scss'
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { Box } from '@mui/material'

const PopOver = ({
  id: tId = '',
  eid,
  textClassName,
  text,
  content,
  children,
  showLink = true,
  placement = 'right',
  showModal = false,
  isOpen,
}) => {
  const [popoverOpen, setPopoverOpen] = useState(isOpen)

  useEffect(() => {
    showModal && setPopoverOpen(false)
  }, [showModal])
  const togglePopover = () => {
    setPopoverOpen(!popoverOpen)
  }
  return (
    <div id={tId} className="my-popover">
      <TextWrapper
        // onClick={() => {
        //   const elements = document.getElementsByClassName('ppevent')
        //   Array.from(elements).forEach((el) => el.click())
        //   setPopoverOpen(true)
        // }}
        className={classnames('pointer bg-grey', { link: showLink }, textClassName)}
      >
        <Box
          id={'fevt' + eid}
          onClick={() => {
            const elements = document.getElementsByClassName('ppevent')
            Array.from(elements).forEach((el) => el.click())
            // setPopoverOpen(true)
            togglePopover()
          }}
        >
          {text}
        </Box>
      </TextWrapper>
      <Popover
        popperClassName="w-100"
        placement={placement}
        isOpen={popoverOpen}
        target={tId}
        // enableresize={'true'}
      >
        <PopoverHeader className="align-items-center d-flex justify-content-between">
          <TextWrapper className="mb-0">{content}</TextWrapper>
          <TextWrapper
            className="mb-0 cpointer ppevent"
            onClick={() => {
              // console.log('aadf')
              // setPopoverOpen(false)
              togglePopover()
            }}
          >
            X
          </TextWrapper>

          {/* <IconButton
            // onClick={() => {
            //   console.log('click')
            // }}
            className="pointer aads"
            iconClassName="icon-color"
            icon={faClose}
          /> */}
        </PopoverHeader>
        <PopoverBody>{children}</PopoverBody>
      </Popover>
    </div>
  )
}

export default PopOver
